
import {computed} from 'vue';
import { useDisplay  } from 'vuetify';
export function useScreenSize() {
    const { mobile, mdAndUp } = useDisplay()
    
    const isDesktop = computed(() => mdAndUp);
    const isMobile = computed(() => mobile);
    return {
        isDesktop,
        isMobile,
    }
};